<template>
  <div class="fourElements">
    <div class="fourElementsContainer">
      <div class="oh fl mr20">
        <div class="fl lh30">品牌：</div>
        <div class="fl">
          <a-select
            ref="select"
            v-model:value="searchParams.brandId"
            style="width: 120px"
            placeholder="请选择"
          >
            <a-select-option
              :value="item.brandId"
              :key="item.brandId"
              v-for="item in siteArr"
              >{{ item.brandName }}</a-select-option
            >
          </a-select>
        </div>
      </div>

      <div class="oh fl mr20">
        <div class="fl lh30">渠道：</div>
        <div class="fl">
          <a-select
            ref="select"
            v-model:value="searchParams.channelId"
            style="width: 120px"
            placeholder="请选择"
          >
            <a-select-option
              :value="item.channelId"
              :key="item.channelId"
              v-for="item in channels"
              >{{ item.channelName }}</a-select-option
            >
          </a-select>
        </div>
      </div>

      <div class="oh fl  mr20">
        <div class="fl lh30">站点：</div>
        <div class="fl">
          <a-select
            ref="select"
            v-model:value="searchParams.siteId"
            style="width: 120px"
            placeholder="请选择"
          >
            <a-select-option
              :value="item.siteId"
              :key="item.siteId"
              v-for="item in sites"
              >{{ item.siteName }}</a-select-option
            >
          </a-select>
        </div>
      </div>
      <div class="oh fl">
        <div class="fl lh30">终端：</div>
        <div class="fl">
          <a-select
            ref="select"
            v-model:value="searchParams.terminalId"
            style="width: 120px"
            placeholder="请选择"
          >
            <a-select-option
              :value="item.terminalId"
              :key="item.terminalId"
              v-for="item in terminals"
            >
              {{ item.terminalName }}
            </a-select-option>
          </a-select>
        </div>
      </div>
    </div>
    <!-- <div class="tar">
      <a-button
        class="mr10"
        type="primary"
        @click="$emit('KeyModal', { opera: 'add' })"
      >
        新增key值
      </a-button>
    </div> -->
  </div>
  <a-modal
    v-model:visible="isVisible1"
    title="个性化设置"
    @ok="handleOk"
    okText="保存"
    cancelText="取消"
    :confirm-loading="confirmLoading"
  >
    <div class="wrap">
      <div style="margin-bottom: 8px;">
        <h4 style="margin-bottom: 8px;">用户维度</h4>
        <a-checkbox v-model:checked="prompt"
          >新建collection后，自动弹出推送终端提示</a-checkbox
        >
      </div>
      <div>
        <h4 style="margin-bottom: 8px;">站点维度</h4>
        <a-checkbox v-model:checked="sync"
          >权重排序时，权重基础分自动同步web端</a-checkbox
        >
      </div>
    </div>
  </a-modal>
</template>
<script>
import { inject, reactive, toRefs, watch, watchEffect } from 'vue'
import {
  collection_special_save,
  collection_special_query
} from '@/server/modules/41299.js'
import { message } from 'ant-design-vue'
export default {
  setup() {
    const initData = inject('initState')
    const state = reactive({
      isVisible1: false,
      checked: true,
      prompt: true,
      sync: true,
      confirmLoading: false,
      configParams: {
        prompt: '',
        sync: '',
        promptId: '',
        syncId: '',
        siteId: ''
      },
      // computed(() => ({
      //   prompt: state.prompt ? 0 : 1, //是否弹出终端提示 0-不弹出，1-弹出
      //   sync: state.sync ? 1 : 0 // 是否同步web端权重原始值， 0-不同步，1-同步
      // })),
      handleOk() {
        state.saveCollectionConifg()
      },
      showModal() {
        state.getCollectionConfig()
        state.isVisible1 = true
      },
      async saveCollectionConifg() {
        try {
          state.confirmLoading = true
          const params = {
            ...state.configParams
          }
          params.prompt = state.prompt ? 1 : 0
          params.sync = state.sync ? 1 : 0
          params.siteId = initData.searchParams.siteId

          let { success, retInfo } = await collection_special_save(params, {
            isFilter: true
          })
          if (success) {
            state.isVisible1 = false
            state.getCollectionConfig()
          } else {
            message.error(retInfo)
          }
          state.confirmLoading = false
        } catch (error) {
          console.log('error', error)
          state.confirmLoading = false
        }
      },
      async getCollectionConfig() {
        let { success, data, retInfo } = await collection_special_query(
          initData.searchParams.siteId
        )
        if (success) {
          state.configParams = data
          state.prompt = data.prompt === 1 ? true : false
          state.sync = data.sync === 1 ? true : false
        } else {
          message.error(retInfo)
        }
      }
    })

    watchEffect(() => {
      if (initData.searchParams.siteId) {
        state.getCollectionConfig()
      }
    })
    watch(
      () => initData.searchParams.brandId,
      n => {
        if (n) {
          initData.searchParams.channelId = undefined
          initData.channels = initData.siteArr.find(
            v => v.brandId === n
          )?.channels
          setTimeout(() => {
            initData.searchParams.channelId = initData.channels?.[0]?.channelId
          }, 50)
        }
      }
    )
    watch(
      () => initData.searchParams.channelId,
      n => {
        if (n) {
          initData.searchParams.siteId = undefined
          initData.sites = initData.channels.find(v => v.channelId === n)?.sites
          setTimeout(() => {
            initData.searchParams.siteId = initData.sites?.[0]?.siteId
          }, 50)
        }
      }
    )
    watch(
      () => initData.searchParams.siteId,
      n => {
        if (n) {
          initData.searchParams.terminalId = undefined
          const site = initData.sites.find(v => v.siteId === n)
          initData.terminals = site?.terminals
          setTimeout(() => {
            initData.searchParams.terminalId =
              initData.terminals?.[0]?.group?.[0]?.terminalId
          }, 50)
        }
      }
    )

    watch(
      () => initData.searchParams.terminalId,
      n => {
        if (n) {
          initData.resetSiteInfo(
            initData.terminals.find(
              v => v.terminalId === initData.searchParams.terminalId
            )
          )
        }
      }
    )
    return {
      ...toRefs(initData),
      ...toRefs(state)
    }
  }
}
</script>
<style scoped>
.fourElements {
  background: #ffffff;
  padding: 10px 20px 20px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.fourElementsContainer {
  display: flex;
  flex-direction: row;
}
</style>
